import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Divider, Button, Tabs, Typography, Spin, Drawer } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Cookies } from 'react-cookie';
import axios from 'axios';
const cookies = new Cookies();
var token = cookies.get('token');
const { Text, Link } = Typography;

const mapStoreToProps = (store) => {
    return {
    };
};

class AtmeLists extends Component {

    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
    }

    state = {
        show: false,
        data: [],
        noread_data: [],
        apiMore: '',
        loading: false,
        moreLoaded: false,
        activeTab: '1',
    }

    componentDidMount() {
        this.props.onRef(this);
        // this.showModal();
    }

    showModal = () => {
        // localStorage.removeItem('atme_message_count');
        localStorage.setItem('atme_message_count', this.props.atme_message_count);
        this.fetchAtmeNoRead();
        this.setState({
            show: true
        });
    }

    fetchAtmeNoRead = () => {
        this.setState({ loading: true });
        axios.get(window.api + 'admin/fetchAtme?no_read=1&token=' + token)
            .then((response) => {
                this.setState({
                    noread_data: response.data.data.data,
                    apiMore: response.data.data.next_page_url,
                    loading: false,
                    moreLoaded: true,
                });
                // this.props.fetchRoles();
            })
            .catch((error) => {
            })
    }

    loadMore = () => {
        this.setState({ loading: true });
        axios.get(this.state.apiMore + '&no_read=1&token=' + token)
            .then((response) => {
                const dataMore = this.state.noread_data.concat(response.data.data.data);
                this.setState({
                    noread_data: dataMore,
                    apiMore: response.data.data.next_page_url,
                    loading: false,
                    moreLoaded: true,
                });
            })
            .catch(function (error) {
                //   message.error(error.response.data.errors);
            });
    };

    fetchAtme = () => {
        this.setState({ loading: true });
        axios.get(window.api + 'admin/fetchAtme?token=' + token)
            .then((response) => {
                this.setState({
                    data: response.data.data,
                    loading: false,
                });
                // this.props.fetchRoles();
            })
            .catch((error) => {
            })
    }

    fetchAtMeMessage = () => {
        this.setState({ loading: true });
        axios.get(window.api + 'admin/fetchAtMeMessage?token=' + token)
            .then((response) => {
                this.setState({
                    data: response.data.data,
                    loading: false,
                });
                // this.props.fetchRoles();
            })
            .catch((error) => {
            })
    }

    handleCancel = () => {
        this.setState({
            show: false,
        });
    }

    onChangeTab = (key) => {
        this.setState({ activeTab: key });
        if (key === '2') {
            this.fetchAtme();
        }
        if (key === '3') {
            this.fetchAtMeMessage();
        }
    }

    render() {
        return (
            <>
                <Drawer
                    destroyOnClose
                    title="留言"
                    placement="right"
                    closable={false}
                    open={this.state.show}
                    onClose={this.handleCancel}
                    width={'400px'}
                >
                    {/* <Modal
                    open={this.state.show}
                    title={`我的留言`}
                    onOk={(e) => { }}
                    onCancel={this.handleCancel}
                    footer={[
                    ]}> */}
                    <Tabs activeKey={this.state.activeTab} onChange={this.onChangeTab} items={[{
                        key: '1',
                        label: '我的留言-未处理',
                        children: <>
                            <Spin spinning={this.state.loading} tip="Loading"></Spin>
                            {this.state.noread_data.map((e) => {
                                return (
                                    <>
                                        <Row>
                                            <Col>
                                                <Text style={{ fontSize: '12px', color: e.status ? '#FFF' : 'gray' }} delete={e.status ? false : true}>{e.message}</Text>
                                                <br />
                                                <span style={{ fontSize: '12px', color: e.status ? '#FFF' : 'gray' }}><Text delete={e.status ? false : true} style={{ color: e.status ? '#FFF' : 'gray' }}>{e.notices}<br /><span style={{ fontSize: '10px', color: '#5bc0de' }}>{e.user_name}</span> - <span style={{ fontSize: '10px' }}>{e.created_at}</span></Text></span>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginBottom: '0px', fontSize: '12px' }}>
                                            <Col span={24}>
                                                <Divider orientation="right" style={{ margin: '0', fontSize: '10px', color: e.status ? '#FFF' : 'gray' }}><Text delete={e.status ? false : true} style={{ color: e.status ? '#FFF' : 'gray' }}>来源 &nbsp;
                                                    {
                                                        <>
                                                            {((e.type == 'home') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href='/todolist'>AOI留言</a>
                                                                : null)}

                                                            {((e.type == 'order') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/order/${e.table_1}`}>Order</a>
                                                                : null)}

                                                            {((e.type == 'invoice') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/invoice/${e.table_1}`}>Invoice</a>
                                                                : null)}

                                                            {((e.type == 'inquiry') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/inquiry/${e.table_1}`}>Inquiry</a>
                                                                : null)}
                                                        </>
                                                    }
                                                </Text>
                                                </Divider>
                                            </Col>
                                        </Row>
                                    </>)
                            })}

                            {this.state.apiMore && (
                                <div className="text-center">
                                    <Button
                                        onClick={this.loadMore}
                                        shape="round"
                                        loading={this.state.loading}
                                    >
                                        {'加载更多'}
                                    </Button>
                                    <br />
                                    <br />
                                    <br />
                                </div>
                            )}

                            {this.state.apiMore === null && this.state.moreLoaded === true && (
                                <div className="text-center">
                                    <p>{'所有数据已加载完毕'}</p>
                                    <br />
                                    <br />
                                    <br />
                                </div>
                            )}
                        </>,
                    },
                    {
                        key: '2',
                        label: '我的留言-已处理',
                        children: <>
                            <Spin spinning={this.state.loading} tip="Loading"></Spin>

                            {this.state.data.map((e) => {
                                return (
                                    <>
                                        <Row>
                                            <Col>
                                                <Text style={{ fontSize: '12px', color: e.status ? '#FFF' : 'gray' }} delete={e.status ? false : true}>{e.message}</Text>
                                                <br />
                                                <span style={{ fontSize: '12px', color: e.status ? '#FFF' : 'gray' }}>
                                                    <Text delete={e.status ? false : true} style={{ color: e.status ? '#FFF' : 'gray' }}>
                                                        {e.notices}
                                                        <br />
                                                        处理时间:{e.updated_at}
                                                    </Text>
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginBottom: '0px', fontSize: '12px' }}>
                                            <Col span={24}>
                                                <Divider orientation="right" style={{ margin: '0', fontSize: '10px', color: e.status ? '#FFF' : 'gray' }}><Text delete={e.status ? false : true} style={{ color: e.status ? '#FFF' : 'gray' }}>来源 &nbsp;
                                                    {
                                                        <>
                                                            {((e.type == 'home') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href='/todolist'>AOI留言</a>
                                                                : null)}

                                                            {((e.type == 'order') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/order/${e.table_1}`}>Order</a>
                                                                : null)}

                                                            {((e.type == 'invoice') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/invoice/${e.table_1}`}>Invoice</a>
                                                                : null)}

                                                            {((e.type == 'inquiry') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/inquiry/${e.table_1}`}>Inquiry</a>
                                                                : null)}
                                                        </>
                                                    }
                                                </Text>
                                                </Divider>
                                            </Col>
                                        </Row>
                                    </>)
                            })}
                        </>,
                    },
                    {
                        key: '3',
                        label: '留言@我的',
                        children: <>
                            <Spin spinning={this.state.loading} tip="Loading"></Spin>

                            {this.state.data.map((e) => {
                                return (
                                    <>
                                        <Row>
                                            <Col>
                                                <Text style={{ fontSize: '12px', color: e.status ? '#FFF' : 'gray' }} delete={e.status ? false : true}>{e.message}</Text>
                                                <br />
                                                <span style={{ fontSize: '12px', color: e.status ? '#FFF' : 'gray' }}>
                                                    <Text delete={e.status ? false : true} style={{ color: e.status ? '#FFF' : 'gray' }}>
                                                        {e.notices}<br /><span style={{ fontSize: '10px', color: '#5bc0de' }}>{e.user_name}</span> - <span style={{ fontSize: '10px' }}>{e.created_at}</span>
                                                    </Text>
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginBottom: '0px', fontSize: '12px' }}>
                                            <Col span={24}>
                                                <Divider orientation="right" style={{ margin: '0', fontSize: '10px', color: e.status ? '#FFF' : 'gray' }}><Text delete={e.status ? false : true} style={{ color: e.status ? '#FFF' : 'gray' }}>来源 &nbsp;
                                                    {
                                                        <>
                                                            {((e.type == 'home') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href='/todolist'>AOI留言</a>
                                                                : null)}

                                                            {((e.type == 'order') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/order/${e.table_1}`}>Order</a>
                                                                : null)}

                                                            {((e.type == 'invoice') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/invoice/${e.table_1}`}>Invoice</a>
                                                                : null)}

                                                            {((e.type == 'inquiry') ?
                                                                <a target={'_blank'} style={{ color: e.status ? '#1890ff' : 'gray' }} href={`/inquiry/${e.table_1}`}>Inquiry</a>
                                                                : null)}
                                                        </>
                                                    }
                                                </Text>
                                                </Divider>
                                            </Col>
                                        </Row>
                                    </>)
                            })}
                        </>,
                    }]} />
                </Drawer>
            </>
        );
    }
}

export default connect(mapStoreToProps)(AtmeLists);